import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component'
import { MenuComponent } from './menu/menu.component'
import { AdministracaoComponent } from './administracao/administracao.component'
import { ClientesComponent } from './clientes/clientes.component'
import { CadastroClienteComponent } from './cadastro-cliente/cadastro-cliente.component'
import { UsuariosComponent } from './usuarios/usuarios.component'
import { CadastroUsuarioComponent } from './cadastro-usuario/cadastro-usuario.component'
import { BuscaDocumentosComponent } from './busca-documentos/busca-documentos.component'
import { FileUploadComponent } from './file-upload/file-upload.component'
import { CadastroTipoDocumentoComponent } from './cadastro-tipo-documento/cadastro-tipo-documento.component'
import { TiposDocumentoComponent } from './tipos-documento/tipos-documento.component'
import { TrocaSenhaComponent } from './troca-senha/troca-senha.component'
import { PdfViewComponent } from './pdf-view/pdf-view.component'

const routes: Routes = [
  { path: 'menu', component: MenuComponent },
  { path: 'login', component: LoginComponent },
  { path: 'administracao', component: AdministracaoComponent },
  { path: 'clientes', component: ClientesComponent },
  { path: 'cadastro-cliente/:id', component: CadastroClienteComponent },
  { path: 'usuarios', component: UsuariosComponent },
  { path: 'cadastro-usuario/:id', component: CadastroUsuarioComponent },
  { path: 'cadastro-tipo-documento/:id', component: CadastroTipoDocumentoComponent },
  { path: 'tipos-documento', component: TiposDocumentoComponent },
  { path: 'documentos-ged', component: BuscaDocumentosComponent },
  { path: 'upload', component: FileUploadComponent },
  { path: 'password', component: TrocaSenhaComponent},
  { path: 'pdf-view/:id', component: PdfViewComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
